import { useModal } from 'mui-modal-provider';
import { useCallback } from 'react';
import SwitchCompaniesDialog from './SwitchCompaniesDialog';

/**
 * Opens the Switch Companies dialog. Shared by every place that offers a switch -- the profile
 * menu and the footer's pharmacy badge -- so they always show the same dialog.
 */
const useSwitchCompaniesDialog = () => {
  const { showModal } = useModal();

  return useCallback(() => {
    const modal = showModal(SwitchCompaniesDialog, {
      title: 'Switch Pharmacies',
      hideDialog: () => {
        modal.hide();
      }
    });
  }, [showModal]);
};

export default useSwitchCompaniesDialog;
